<template>
  <v-list-item :to="{ name: 'entities.manage', params: { id: entity.id } }">
    <item-logo
      :src="entity.entity.default.logoFeatured"
      :symbol="entity.entity.default.symbol"
      :name="entity.entity.default.name"
      :color="logoColor"
      :dark="logoDark"
    />

    <v-list-item-content class="d-flex items-center pl-4">
      <div class="d-flex">
        <v-list-item-title class="d-flex align-center">
          <span>
            {{ entity.entity.default.name }}
          </span>
          <v-spacer />
          <base-chip :text="entity.entityType.name" icon="label" color="light-blue" class="ml-5" small dark />
        </v-list-item-title>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import BaseChip from '@/components/chips/base-chip'
import ItemLogo from '@/components/item-logo'

export default {
  name: 'EntityItem',
  components: { BaseChip, ItemLogo },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    logoDark() {
      const {
        entity: {
          default: { symbol, logoFeatured },
        },
      } = this.entity
      if (logoFeatured) return false
      if (symbol) return true
      return false
    },
    logoColor() {
      const {
        entity: {
          default: { symbol, logoFeatured },
        },
      } = this.entity
      if (logoFeatured) return 'grey lighten-2'
      if (symbol) return 'secondary'
      return 'grey lighten-2'
    },
  },
}
</script>
